import script from "./TripWaypointsRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./TripWaypointsRegister.vue?vue&type=script&setup=true&lang=js"

import "./TripWaypointsRegister.vue?vue&type=style&index=0&id=01a983ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a983ef"]])

export default __exports__